export const config = {
  rowSelection: false,
  fieldControl: false,
  columns: [
    {
      title: '编码',
      dataIndex: 'code',
      width: 100,
    },
    {
      title: '单位名称',
      dataIndex: 'name',
      width: 100,
    },
    {
      title: '类别',
      dataIndex: 'typeStr',
      width: 100,
    },
    {
      title: '别名1',
      dataIndex: 'alias1',
      width: 100,
    },
    {
      title: '别名2',
      dataIndex: 'alias2',
      width: 100,
    },
    {
      title: '别名3',
      dataIndex: 'alias3',
      width: 100,
    },
    {
      title: '是否有效',
      dataIndex: 'enabled',
      width: 100,
      render: (text, record) => {
        return text ? '是' : '否'
      },
    },
    {
      title: '操作',
      width: 100,
      render: 'optionCell',
      fixed: 'right',
    },
  ],
  search: [
    {
      name: 'name',
      label: '单位名称',
    },
    {
      name: 'type',
      label: '单位类别',
      itemType: 'select',
      key: 'key',
      labelKey: 'description',
      data: 'UnitTypeEnum',
      optionFilterProp: 'children',
      showSearch: true,
    },
  ],
  footer: [
    {
      label: '新建',
      // "auth": "unitButton1",
      type: 'primary',
      events: ['onClick:onAdd'],
    },
  ],
  batchActions: [],
}
